import { useQuery, useQueryClient } from '@tanstack/react-query';
import useRecipes from './useRecipes';

const useRecipe = ({ id }) => {
  const queryClient = useQueryClient();
  const recipesQuery = useRecipes();
  return useQuery({
    queryKey: ['recipe', id],
    queryFn: () => {
      const recipes = queryClient.getQueryData(['recipes']);

      const recipe = recipes?.find((r) => r.id === id) || null;

      if (!recipe) {
        throw new Error('Receta no encontrada');
      }

      return recipe;
    },
    enabled: recipesQuery.isSuccess,
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });
};

export default useRecipe;
